import { createTimestampedAction } from '@app/helpers';

export const routeSelected = createTimestampedAction(
  '[Routes Page] Route Selected',
  (route: string) => ({
    options: { route },
  })
);
